/* Orbit Card Show V684.0.0.
 * Discover the PRODUCT by its owned description, native form and variant IDs.
 * Do not depend on a theme name, a .row parent or a guessed .col-* class.
 * Forms, app controls, listeners, inventory and submission behavior are retained.
 */
(function () {
  'use strict';
  var BUILD = 'v68400', DATA_ID = 'orbit-event-data-v68400';
  var MARKER = '.orbit-event-copy-v681,.orbit-event-copy-v680';
  var mounted = null, observer = null, timer = null, started = 0;
  var MAX_DEPTH = 18, activeShopId = '';
  var firstPartyHosts = ['orbitcardshow.co.uk','www.orbitcardshow.co.uk','4b1z9j-2x.myshopify.com'];
  function diagnostic(code, details) {
    document.documentElement.dataset.orbitEventDesign = code;
    // No field values, customer details, preview keys or credentials are logged.
    window.orbitEventLayoutDiagnostic = {build: BUILD, code: code, details: details || {}};
  }
  function shown(el) {
    if (!el || el.hidden || el.closest('[hidden],[aria-hidden="true"]')) return false;
    var style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && !!el.getClientRects().length;
  }
  function controls(form) { return Array.from(form.elements || []); }
  function variantInput(form, ids) {
    return controls(form).find(function (field) { return field.name === 'id' && ids.has(String(field.value)); });
  }
  function commonAncestor(a, b) {
    for (var n = a, depth = 0; n && depth < MAX_DEPTH; n = n.parentElement, depth++) if (n === b || n.contains(b)) return n;
    return null;
  }
  function distance(a, parent) { var d = 0; for (; a && a !== parent; a = a.parentElement) d++; return d; }
  function directBranch(root, node) {
    if (node === root) return null;
    for (var n = node; n && n.parentElement; n = n.parentElement) if (n.parentElement === root) return n;
    return null;
  }
  function imageKey(value) {
    if (!value) return '';
    // Keep full host+path identity, discarding only Shopify resize parameters.
    // SVG/data fixtures are allowed here only as an identity, never as markup.
    if (/^data:image\//.test(value)) return value;
    try {
      var u = new URL(value, window.location.href);
      if (u.protocol !== 'https:' && u.protocol !== 'http:') return '';
      var path = decodeURIComponent(u.pathname);
      // Shella's actual saved gallery emits foo_490x@3x.progressive.png.jpg
      // and data-master=foo_{width}x.progressive.png.jpg for the original
      // foo.png. Recognise only the bounded resize/format suffix; never use
      // alt-text or a filename substring to identify another shop's media.
      path = path.replace(/_(?:\d+x\d*|x\d+|\{width\}x)(?:@[234]x)?\.progressive\.(png|jpe?g)(?:\.jpe?g)?$/i, '.$1');
      path = path.replace(/_(?:\d+x\d*|x\d+|\{width\}x|small|medium|large|grande|master)(?:@[234]x)?(?=\.[a-z]+$)/i, '');
      // Shopify renders the same image through two native URL aliases. Match
      // them without depending on the selected resize or custom-domain host.
      var local = firstPartyHosts.includes(u.hostname) || activeShopId && u.hostname.endsWith('-'+activeShopId+'.shopifypreview.com');
      var tenant = path.match(/^\/s\/files\/\d+\/([0-9/]+)\/(files|products)\/(.+)$/);
      if(u.hostname==='cdn.shopify.com' && tenant && (!activeShopId || tenant[1].replace(/\//g,'').replace(/^0+/,'')===activeShopId)) return 'shopify-media:'+tenant[2]+'/'+tenant[3];
      if(local && /^\/cdn\/shop\/(?:files|products)\//.test(path)) return 'shopify-media:'+path.replace(/^\/cdn\/shop\//,'');
      return u.hostname + path;
    } catch (_) { return ''; }
  }
  function imageKeys(el) {
    var values = [el.currentSrc, el.getAttribute('src'), el.getAttribute('data-src'), el.getAttribute('data-original'), el.getAttribute('data-zoom-image'), el.getAttribute('data-master')];
    ['srcset', 'data-srcset'].forEach(function (name) {
      (el.getAttribute(name) || '').split(',').forEach(function (part) { values.push(part.trim().split(/\s+/)[0]); });
    });
    var picture=el.closest('picture'); if(picture)picture.querySelectorAll('source').forEach(function(source){(source.getAttribute('srcset')||source.getAttribute('data-srcset')||'').split(',').forEach(function(part){values.push(part.trim().split(/\s+/)[0]);});});
    var a = el.closest('a'); if (a) values.push(a.getAttribute('href'));
    return values.map(imageKey).filter(Boolean);
  }
  function isCartForm(form) {
    try { return /\/cart\/add\/?$/.test(new URL(form.getAttribute('action') || '', window.location.href).pathname); }
    catch (_) { return false; }
  }
  function isPurchaseField(field) {
    return /^(?:id|quantity|selling_plan|properties\[)/.test(field.name || '') || field.type === 'submit';
  }
  function canHideMedia(node, marker, form) {
    if (!node || node === marker || node.contains(marker) || node === form || node.contains(form)) return false;
    if (node.querySelector('form,iframe,[data-easify],.easify-options,.easify-product-options')) return false;
    // Slider arrows/radios and zoom controls are media controls, not a reason
    // to reject the entire page. Purchase fields must NEVER be hidden.
    return !Array.from(node.querySelectorAll('input,select,textarea,button')).some(isPurchaseField);
  }
  function hasPurchaseAction(form) {
    return controls(form).some(function (field) { return field.type === 'submit'; });
  }
  function sameProductPaymentTerms(form, purchaseForm, data, ids) {
    // The saved Shella page has a second /cart/add instalment form. It is not
    // another event. Accept only this non-interactive helper with explicit
    // product AND section ownership and the SAME selected native variant.
    // Never exclude an arbitrary second cart form, even with the same SKU.
    if (!form.matches('form.installment') || hasPurchaseAction(form)) return false;
    var fields = controls(form), purchaseFields = controls(purchaseForm);
    if (!fields.length || fields.some(function (field) { return field.type !== 'hidden'; }) ||
        form.querySelector('button,[role="button"],a[href]')) return false;
    var value = function (list, name) { var found=list.filter(function(f){return f.name===name;});return found.length===1?String(found[0].value):''; };
    var variant = variantInput(form,ids), selected=variantInput(purchaseForm,ids);
    return !!(data.productId && variant && selected && String(variant.value)===String(selected.value) &&
      value(fields,'product-id')===String(data.productId) && value(purchaseFields,'product-id')===String(data.productId) &&
      value(fields,'section-id') && value(fields,'section-id')===value(purchaseFields,'section-id'));
  }
  function resolve(data) {
    var ids = new Set(data.variants.map(function (v) { return String(v.id); }));
    var forms = Array.from(document.forms).filter(function (f) { return isCartForm(f) && variantInput(f, ids) && hasPurchaseAction(f); });
    var markers = Array.from(document.querySelectorAll(MARKER)).filter(function (m) { return !m.closest('.orbit-booking-tail'); });
    var pairs = [];
    markers.forEach(function (marker) {
      forms.forEach(function (form) {
        var host = commonAncestor(marker, form);
        if (!host || /^(?:BODY|HTML)$/.test(host.tagName)) return;
        var score = distance(marker, host) + distance(form, host) + (shown(marker) ? 0 : 100);
        pairs.push({marker: marker, form: form, host: host, score: score, idInput: variantInput(form, ids)});
      });
    });
    pairs.sort(function (a, b) { return a.score - b.score; });
    if (!pairs.length) return {error: 'product-form-pending', details: {markers: markers.length, matchingForms: forms.length}};
    if (pairs.length > 1 && pairs[0].score === pairs[1].score && pairs[0].form !== pairs[1].form) return {error: 'ambiguous-product-form'};
    var p = pairs[0], keys = new Set((data.images || []).map(function (x) { return imageKey(x.url); }).filter(Boolean));
    keys.add(imageKey(data.image)); keys.delete('');
    var media = Array.from(document.querySelectorAll('img')).filter(function (img) {
      return !img.closest(MARKER + ',.orbit-booking-tail,footer,nav,[role="dialog"]') && imageKeys(img).some(function (key) { return keys.has(key); });
    });
    // Starting at the owned description, find the SMALLEST product region that
    // contains its native controls AND a separate matching media branch. The
    // form may wrap this region or sit inside it. Neither layout is guessed.
    var root = null, gallery = [], column = null;
    for (var n = p.marker.parentElement, depth = 0; n && depth < MAX_DEPTH && !/^(?:BODY|HTML)$/.test(n.tagName); n = n.parentElement, depth++) {
      if (!(n.contains(p.form) || p.form.contains(n))) continue;
      var fields = controls(p.form).filter(function (f) { return isPurchaseField(f) && f.type !== 'hidden'; });
      if (!fields.length || !fields.every(function (f) { return n.contains(f); })) continue;
      var matched = media.filter(function (img) { return n.contains(img); });
      if (!matched.length) continue;
      var infoBranch = directBranch(n, p.marker);
      var branches = Array.from(new Set(matched.map(function (img) { return directBranch(n, img); }).filter(Boolean)));
      var separate = branches.filter(function (b) { return b !== infoBranch && canHideMedia(b, p.marker, p.form); });
      // If both columns are under one neutral wrapper, go one level deeper via
      // the ancestor walk, not by assuming wrapper.parentElement is .row.
      if (!separate.length) continue;
      var otherForms = Array.from(n.querySelectorAll('form')).filter(function (f) { return f !== p.form && isCartForm(f) && !sameProductPaymentTerms(f,p.form,data,ids); });
      if (otherForms.length) continue; // Never absorb another product / quick-buy.
      root = n; gallery = separate;
      column = infoBranch && fields.every(function (f) { return infoBranch.contains(f); }) ? infoBranch : null;
      break;
    }
    if (!root) {
      // Deterministic fallback for the store's verified Shella 6.5.4 product DOM.
      // The native add-to-cart form ID is declared by <single-product>; require
      // that exact form, the owned event-description marker, and exactly one
      // sibling gallery branch before touching layout. This is intentionally
      // narrower than the generic discovery path and never guesses another app.
      var shell = p.marker.closest('single-product[data-form-id]');
      if (shell) {
        var formId = shell.getAttribute('data-form-id') || '';
        var declared = formId ? document.getElementById(formId) : null;
        var shellRow = Array.from(shell.children || []).find(function (child) { return child.classList && child.classList.contains('row'); });
        if (declared === p.form && shellRow && isCartForm(declared) && variantInput(declared, ids) && hasPurchaseAction(declared)) {
          var shellInfo = directBranch(shellRow, p.marker);
          var shellGallery = Array.from(shellRow.children || []).filter(function (branch) {
            return branch !== shellInfo && !!branch.querySelector('product-gallery,[data-js-product-gallery]') && canHideMedia(branch, p.marker, declared);
          });
          var shellFields = controls(declared).filter(function (f) { return isPurchaseField(f) && f.type !== 'hidden'; });
          var shellOther = Array.from(shellRow.querySelectorAll('form')).filter(function (f) { return f !== declared && isCartForm(f) && !sameProductPaymentTerms(f, declared, data, ids); });
          if (shellInfo && shellGallery.length === 1 && shellFields.length && shellFields.every(function (f) { return shellInfo.contains(f); }) && !shellOther.length) {
            root = shellRow; gallery = shellGallery; column = shellInfo;
          }
        }
      }
    }
    if (!root) return {error: 'product-region-pending', details: {matchingMedia: media.length, matchingForms: forms.length, ancestorDepth: distance(p.marker, p.host)}};
    var headingScope = column || root;
    var title = Array.from(headingScope.querySelectorAll('h1,h2,.tt-title,[data-product-title],.product-title')).find(function (x) { return !x.closest(MARKER) && !!(x.compareDocumentPosition(p.marker) & Node.DOCUMENT_POSITION_FOLLOWING) && !gallery.some(function (g) { return g.contains(x); }); });
    // Absence of a theme-specific heading is harmless: our verified event data
    // supplies the title. It must not block preview of an otherwise valid form.
    return {marker: p.marker, form: p.form, idInput: p.idInput, root: root, column: column, gallery: gallery, title: title, ids: ids};
  }
  function setLayoutPath(node, root) {
    for (var n = node; n && n !== root; n = n.parentElement) {
      if (n.matches('div,section,article,product-info') && !n.matches(MARKER)) {
        n.classList.add('orbit-native-info-path');
        n.style.setProperty('width', '100%', 'important');
        n.style.setProperty('max-width', 'none', 'important');
        n.style.setProperty('min-width', '0', 'important');
        n.style.setProperty('float', 'none', 'important');
      }
    }
  }
  function addChoices(data, layout) {
    if (data.variants.length < 2 || data.optionCount !== 1) return;
    var form = layout.form, selected = String(layout.idInput.value), changing = false;
    var group = document.createElement('fieldset'); group.className = 'orbit-booking-choice';
    var legend = document.createElement('legend'); legend.textContent = 'Choose your table option'; group.appendChild(legend);
    var status = document.createElement('p'); status.className = 'orbit-choice-status'; status.setAttribute('aria-live', 'polite');
    status.textContent = 'Select the table you want to reserve. Changing table type refreshes the booking page so Shopify and Easify load the correct option.';
    data.variants.forEach(function (v) {
      var label = document.createElement('label'), radio = document.createElement('input');
      radio.type = 'radio'; radio.setAttribute('aria-label',v.title); radio.value = String(v.id); radio.checked = selected === String(v.id);
      var name = document.createElement('span'); name.textContent = v.title;
      var price = document.createElement('strong'); price.textContent = new Intl.NumberFormat('en-GB', {style: 'currency', currency: data.currency || 'GBP'}).format(v.price / 100);
      label.append(radio, name, price); group.appendChild(label);
      radio.addEventListener('change', function () {
        if (!radio.checked || changing || radio.value === selected) return;
        group.querySelectorAll('input[type=radio]').forEach(function(other){if(other!==radio)other.checked=false;});
        var answers = controls(form).some(function (f) { return /^properties\[/.test(f.name || '') && (/^(?:checkbox|radio)$/.test(f.type) ? f.checked : String(f.value || '').trim()); });
        if (answers && !window.confirm('Change table type? The page will refresh and you will need to re-enter your vendor details and display-case choice.')) {
          group.querySelectorAll('input').forEach(function (f) { f.checked = f.value === selected; }); return;
        }
        var next = new URL(window.location.href); next.searchParams.set('variant', String(v.id)); next.searchParams.delete('option_values');
        if (next.protocol !== 'https:' || next.origin !== window.location.origin) return;
        changing = true; group.setAttribute('aria-busy', 'true'); status.textContent = 'Opening ' + v.title + '…';
        // Let Shopify/the installed app establish price, inventory and add-ons.
        // Do not fake totals or overwrite hidden variant IDs under Easify.
        window.location.assign(next.href);
      });
    });
    group.appendChild(status);
    var externalQuantity = controls(form).find(function(field){return field.name==='quantity'&&!form.contains(field);});
    var quantityBlock=externalQuantity?.closest('.product-page-info__quantity');
    if (quantityBlock && layout.column?.contains(quantityBlock)) quantityBlock.before(group);
    else if (form.contains(layout.marker)) layout.marker.after(group); else form.prepend(group);
    var requested = new URL(window.location.href).searchParams.get('variant');
    var bad = requested && layout.ids.has(requested) && requested !== selected;
    if (bad) { status.textContent = 'The selected table could not be loaded correctly. Please contact Orbit before booking.'; layout.variantMismatch = true; }
    form.addEventListener('submit', function (event) { if (changing || bad) { event.preventDefault(); event.stopImmediatePropagation(); status.scrollIntoView({block: 'center'}); } }, true);
  }

  function money(amount, currency) {
    return new Intl.NumberFormat('en-GB',{style:'currency',currency:currency||'GBP',minimumFractionDigits:0,maximumFractionDigits:2}).format(Number(amount||0)/100);
  }
  function summaryCard(label, value, meta) {
    var card=document.createElement('div');card.className='orbit-summary-card';
    var key=document.createElement('span');key.className='orbit-summary-label';key.textContent=label;
    var main=document.createElement('strong');main.className='orbit-summary-value';main.textContent=value;
    card.append(key,main);
    if(meta){var small=document.createElement('span');small.className='orbit-summary-meta';small.textContent=meta;card.appendChild(small);}
    return card;
  }
  function enhanceOverview(data, layout, dateLabel) {
    var marker=layout.marker, summary=marker.querySelector('.orbit-event-summary');
    if(!summary)return;
    summary.classList.add('orbit-premium-summary');summary.replaceChildren();
    summary.appendChild(summaryCard('Date',dateLabel));
    summary.appendChild(summaryCard('Venue',marker.dataset.orbitVenue));
    var selected=data.variants.find(function(v){return String(v.id)===String(layout.idInput.value);})||data.variants[0];
    if(data.variants.length===1){
      summary.appendChild(summaryCard('Table',selected.title,money(selected.price,data.currency)+' per table'));
    }else{
      var min=Math.min.apply(null,data.variants.map(function(v){return Number(v.price)||0;}));
      summary.appendChild(summaryCard('Table options',data.variants.length+' choices','From '+money(min,data.currency)+' per table'));
    }
    var obsolete=marker.querySelector('.orbit-event-options');if(obsolete){obsolete.hidden=true;obsolete.classList.add('orbit-event-options-superseded');obsolete.style.setProperty('display','none','important');}
    var guide=marker.querySelector('.orbit-event-booking-guide');
    if(guide){
      var h=guide.querySelector('h2');if(h)h.textContent='How booking works';
      guide.querySelectorAll('.orbit-event-feature-card').forEach(function(card,index){
        card.dataset.step=String(index+1);var strong=card.querySelector('strong');if(strong)strong.textContent=strong.textContent.replace(/[🛒📝✅✨🪑]/g,'').replace(/^\s*\d+[.]?\s*/, '').trim();
      });
      guide.querySelectorAll('.orbit-booking-jump').forEach(function(node){node.remove();});
    }
    marker.querySelectorAll('.orbit-event-note strong').forEach(function(node){node.textContent=node.textContent.replace(/^ℹ️\s*/,'');});
  }
  function markReserveRegion(layout, data) {
    var marker=layout.marker, info=marker.closest('.product-page-info');if(!info)return null;
    var description=marker.closest('.product-page-info__description');if(!description)return null;
    var header=info.querySelector('.orbit-reserve-header');
    if(!header){
      header=document.createElement('section');header.className='orbit-reserve-header';
      var title=document.createElement('h2');title.textContent='Reserve your table';
      var copy=document.createElement('p');copy.textContent=data.variants.length>1?'Choose your table option and quantity, then enter your vendor details below.':'Choose how many tables you need, then enter your vendor details below.';
      header.append(title,copy);description.after(header);
    }
    var club=info.querySelector('.orbit-vendor-club-callout');
    if(!club){
      club=document.createElement('aside');club.className='orbit-vendor-club-callout';club.setAttribute('aria-label','Orbit Vendor Club');
      var clubText=document.createElement('div'),clubTitle=document.createElement('strong'),clubCopy=document.createElement('p'),clubLink=document.createElement('a');
      clubTitle.textContent='Earn Vendor Points when you book';clubCopy.textContent='Orbit rewards its vendors. Earn Vendor Points on eligible table bookings and build towards future rewards.';
      clubLink.href='https://orbitvendorclub.co.uk/';clubLink.target='_blank';clubLink.rel='noopener noreferrer';clubLink.textContent='Find out more';
      clubText.append(clubTitle,clubCopy);club.append(clubText,clubLink);header.after(club);
    }
    var children=Array.from(info.children),start=children.indexOf(header);
    children.forEach(function(child,index){if(index>=start)child.classList.add('orbit-reserve-node');});
    info.classList.add('orbit-reserve-active');
    var total=info.querySelector('.product-page-info__text h3');if(total)total.textContent='Booking total';
    var quantity=info.querySelector('.product-page-info__quantity');
    if(quantity){quantity.classList.add('orbit-quantity-premium');var qLabel=quantity.querySelector('label');if(qLabel)qLabel.textContent='Number of tables';}
    var add=info.querySelector('[name="add"] .btn__text');if(add)add.textContent='Add to basket';
    var buy=info.querySelector('[data-js-dynamic-checkout-button-wrapper]');if(buy)buy.classList.add('orbit-dynamic-checkout');
    markEasifyBoundaries(info);
    return {info:info,header:header,description:description};
  }

  function previewRequested() {
    try { return new URL(window.location.href).searchParams.get('orbit_layout_preview') === 'v684'; }
    catch (_) { return false; }
  }
  function bookingCandidate(data) {
    var title=String(data.title||''),handle=String(data.handle||'');
    return /reserve\s+a\s+table/i.test(title)||/reserve-a-table/i.test(handle);
  }
  function eventFacts(data) {
    var title=String(data.title||'').trim(), handle=String(data.handle||'');
    var m=title.match(/\b(\d{1,2})(?:st|nd|rd|th)?\s+(January|February|March|April|May|June|July|August|September|October|November|December)\s+(20\d{2})\b/i);
    var months=['january','february','march','april','may','june','july','august','september','october','november','december'],date='';
    if(m){var month=months.indexOf(m[2].toLowerCase())+1;date=m[3]+'-'+String(month).padStart(2,'0')+'-'+String(Number(m[1])).padStart(2,'0');}
    if(!date){var h=handle.match(/(?:^|-)(20\d{2})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])(?:-|$)/);if(h)date=h[1]+'-'+h[2]+'-'+h[3];}
    var venue=title.split(/\s+-\s+Reserve\s+a\s+Table\b/i)[0].trim();
    if(venue===title)venue=title.replace(/\s+Reserve\s+a\s+Table\b[\s\S]*$/i,'').trim();
    var city=venue.replace(/\b(?:Racecourse|Leisure Centre|Showground|Centre|Center|Hall|Arena|Stadium|University|Campus)\b[\s\S]*$/i,'').trim()||venue;
    return {date:date,venue:venue,city:city};
  }
  function ensureLegacyMarker(data) {
    var existing=document.querySelector(MARKER);if(existing)return existing;
    if(!bookingCandidate(data))return null;
    var description=Array.from(document.querySelectorAll('.product-page-info__description .rte,.product-page-info__description,[data-product-description],.product__description')).find(shown);
    if(!description)return null;
    var facts=eventFacts(data);if(!facts.date||!facts.venue)return null;
    description.classList.add('orbit-event-copy-v680','orbit-event-copy-v681','orbit-event-copy-fallback');
    description.dataset.orbitDate=facts.date;description.dataset.orbitVenue=facts.venue;description.dataset.orbitCity=facts.city;
    if(!description.querySelector('.orbit-event-summary')){var summary=document.createElement('section');summary.className='orbit-event-summary';description.prepend(summary);}
    if(!description.querySelector('.orbit-event-intro-wrap')){
      var intro=document.createElement('section');intro.className='orbit-event-intro-wrap orbit-event-fallback-intro';
      var lead=document.createElement('p');lead.className='orbit-event-intro';lead.textContent='Book your vendor table for '+facts.venue+'.';
      var support=document.createElement('p');support.className='orbit-event-lead';support.textContent='Choose the table option and quantity you need, then complete the vendor booking details below.';
      intro.append(lead,support);var summary=description.querySelector('.orbit-event-summary');summary.after(intro);
    }
    return description;
  }
  function markEasifyBoundaries(info) {
    if(!info)return;
    var selectors='[data-easify],[id*="easify" i],[class*="easify" i],[id*="tpo_" i],[class*="tpo_" i]';
    info.querySelectorAll(selectors).forEach(function(node){
      node.classList.add('orbit-easify-boundary');
      var branch=node;
      while(branch.parentElement&&branch.parentElement!==info&&!branch.parentElement.classList.contains('orbit-reserve-node'))branch=branch.parentElement;
      if(branch&&info.contains(branch))branch.classList.add('orbit-easify-boundary');
    });
  }
  function initialise() {
    var dataNode = document.getElementById(DATA_ID); if (!dataNode) return false;
    var data; try { data = JSON.parse(dataNode.textContent); } catch (_) { diagnostic('invalid-design-data'); return false; }
    if(!data.activated && !(previewRequested()&&bookingCandidate(data))) return false;
    if(!document.querySelector(MARKER))ensureLegacyMarker(data);
    if (!Array.isArray(data.variants) || !data.variants.length || !data.image) { diagnostic('missing-product-data'); return false; }
    activeShopId=String(data.shopId||'').replace(/^0+/,'');
    if(data.shopDomain && data.shopDomain!=='4b1z9j-2x.myshopify.com'){diagnostic('wrong-store-data');return false;}
    var layout = resolve(data);
    if (layout.error) { diagnostic(layout.error, layout.details); return false; }
    var marker = layout.marker, form = layout.form, root = layout.root;
    var date = new Date(marker.dataset.orbitDate + 'T12:00:00Z');
    if (!marker.dataset.orbitVenue || !Number.isFinite(date.getTime())) { diagnostic('invalid-event-data'); return false; }
    var label = new Intl.DateTimeFormat('en-GB', {weekday:'long', day:'numeric', month:'long', year:'numeric', timeZone:'Europe/London'}).format(date);
    var wantedAlt = 'Orbit Card Show in ' + marker.dataset.orbitCity + ', ' + marker.dataset.orbitVenue + ', ' + label.replace(',', '') + '.';
    // Shopify's verified featured order is newest FIRST. Reversing it selected
    // the obsolete pre-watermark artwork when both revisions shared the alt.
    var art = (data.images || []).find(function (img) { return img.alt === wantedAlt; });
    var url = art ? art.url : data.image, alt = art ? art.alt : data.imageAlt || wantedAlt;
    var originalFields = controls(form), owners = originalFields.map(function (f) { return f.form; });
    var auxiliaryForms = Array.from(root.querySelectorAll('form')).filter(function(f){return f!==form;});
    var auxiliaryFields = auxiliaryForms.flatMap(controls), auxiliaryOwners=auxiliaryFields.map(function(f){return f.form;});
    var header = document.createElement('header'); header.className = 'orbit-booking-heading';
    var kicker = document.createElement('p'); kicker.className = 'orbit-booking-kicker'; kicker.textContent = 'Orbit Card Show · Vendor tables';
    var title = document.createElement('h1'); title.className = 'orbit-booking-title'; title.textContent = marker.dataset.orbitVenue;
    header.append(kicker, title);
    var figure = document.createElement('figure'); figure.className = 'orbit-booking-art';
    // Desktop uses a shallower visual derivative without changing/cropping the
    // original 2160x1080 artwork. The original remains the product/mobile asset.
    figure.style.setProperty('--orbit-desktop-hero-bg', 'url(\"' + String(url).replace(/[\"\\]/g, '\\$&') + '\")');
    var image = document.createElement('img'); image.src = url; image.alt = alt; image.width = 2160; image.height = 1080; image.decoding = 'async'; image.fetchPriority = 'high'; figure.appendChild(image);
    // Mutate only after discovery validates the full native booking boundary.
    layout.gallery.forEach(function (node) { node.dataset.orbitNativeGallery = 'true'; node.hidden = true; node.style.setProperty('display','none','important'); });
    if (layout.title) { layout.title.hidden = true; layout.title.style.setProperty('display','none','important'); }
    root.classList.add('orbit-booking-v681');
    if (marker.closest('single-product[data-form-id]')?.getAttribute('data-form-id') === form.getAttribute('id')) root.classList.add('orbit-booking-shella');
    if (layout.column) { layout.column.classList.add('orbit-booking-info'); setLayoutPath(marker.parentElement, root); if(root.contains(form) && form !== root) setLayoutPath(form.parentElement, root); }
    else root.classList.add('orbit-booking-flat');
    root.style.setProperty('display','grid','important'); root.style.setProperty('grid-template-columns','minmax(0,1fr)','important');
    root.style.setProperty('width','100%','important'); root.style.setProperty('min-width','0','important');
    root.prepend(header); root.prepend(figure);
    var tail = document.createElement('div'); tail.className = 'orbit-booking-tail orbit-event-copy-v681';
    marker.querySelectorAll('.orbit-event-photo-story,.orbit-event-venue').forEach(function (section) {
      if (!section.querySelector('form,input,select,textarea')) tail.appendChild(section);
    });
    if (tail.children.length) root.appendChild(tail);
    var map = tail.querySelector('.orbit-event-venue'); if (map) map.id = 'orbit-event-venue';
    enhanceOverview(data, layout, label);
    addChoices(data, layout);
    var reserve=markReserveRegion(layout,data);

    if (/\.shopifypreview\.com$/.test(location.hostname) || new URL(location.href).searchParams.has('preview_theme_id')) {
      var badge = document.createElement('p'); badge.className = 'orbit-design-preview-badge'; badge.textContent = 'V684.0.0 event design preview'; header.prepend(badge);
    }
    marker.querySelectorAll('.orbit-design-error').forEach(function (node) { node.remove(); });
    if (!originalFields.every(function (field, i) { return field.isConnected && field.form === owners[i]; }) || !auxiliaryFields.every(function(field,i){return field.isConnected && field.form===auxiliaryOwners[i];})) {
      diagnostic('native-form-ownership-changed'); return false;
    }
    mounted = {mediaKeys:new Set((data.images||[]).map(function(x){return imageKey(x.url);}).concat([imageKey(data.image)])), marker:marker, root: root, header: header, figure: figure, form: form, column: layout.column, tail: tail, fields: originalFields, owners: owners, variantMismatch: layout.variantMismatch, reserve:reserve, data:data, layout:layout};
    diagnostic(layout.variantMismatch ? 'variant-template-needs-checking' : BUILD, {nativeFieldsRetained: originalFields.length, paymentTermsFormsRetained: auxiliaryForms.length, hiddenMediaRegions: layout.gallery.length, formWrapsProduct: form.contains(root)});
    return true;
  }
  function hideLateGallery() {
    if(!mounted)return;
    var root=mounted.root;
    Array.from(root.querySelectorAll('img')).filter(function(img){return !img.closest('.orbit-booking-art,.orbit-booking-tail,'+MARKER)&&imageKeys(img).some(function(k){return mounted.mediaKeys.has(k);});}).forEach(function(img){
      var branch=directBranch(root,img);
      if(canHideMedia(branch,mounted.marker,mounted.form)&&branch!==mounted.header&&branch!==mounted.figure){branch.dataset.orbitNativeGallery='true';branch.hidden=true;branch.style.setProperty('display','none','important');}
    });
  }
  function layoutCheck() {
    if (!mounted || !mounted.root.isConnected) return;
    hideLateGallery();
    if(mounted.reserve){markReserveRegion(mounted.layout,mounted.data);markEasifyBoundaries(mounted.reserve.info);}
    var image = mounted.figure.getBoundingClientRect();
    var info = (mounted.column || mounted.form).getBoundingClientRect();
    var okay = image.width > 0 && (!mounted.column || Math.abs(image.width - info.width) <= 3) && document.querySelectorAll('.orbit-booking-art').length === 1;
    if (!okay) diagnostic('layout-width-check-failed');
    else if (!mounted.variantMismatch) diagnostic(BUILD, window.orbitEventLayoutDiagnostic?.details);
  }
  function warning() {
    if (!/\.shopifypreview\.com$/.test(location.hostname) && !new URL(location.href).searchParams.has('preview_theme_id')) return;
    var marker = document.querySelector(MARKER); if (!marker || marker.querySelector('.orbit-design-error')) return;
    var message = document.createElement('p'); message.className = 'orbit-design-error'; message.setAttribute('role', 'alert');
    message.textContent = 'The event layout needs checking (' + (document.documentElement.dataset.orbitEventDesign || 'not-ready') + '). Do not publish from this preview.'; marker.prepend(message);
  }
  function maps() {
    document.querySelectorAll('.orbit-map-preview').forEach(function (box) {
      var button = box.querySelector('.orbit-map-load'); if (!button || button.dataset.bound) return; button.dataset.bound = '1';
      button.addEventListener('click', function () {
        var u; try { u = new URL(box.dataset.mapSrc); } catch (_) { return; }
        if (u.protocol !== 'https:' || u.hostname !== 'www.google.com' || u.pathname !== '/maps/embed' || !u.searchParams.has('pb')) return;
        var frame = document.createElement('iframe'); frame.src = u.href; frame.title = 'Map of ' + (box.dataset.mapTitle || 'the event venue'); frame.loading = 'lazy'; frame.referrerPolicy = 'no-referrer-when-downgrade'; frame.setAttribute('allowfullscreen',''); frame.style.cssText='width:100%;height:360px;border:0;border-radius:12px'; box.replaceChildren(frame);
      });
    });
  }
  function start() {
    var dataNode=document.getElementById(DATA_ID);if(!dataNode)return;
    try{var bootData=JSON.parse(dataNode.textContent);if(!bootData.activated&&!(previewRequested()&&bookingCandidate(bootData)))return;}catch(_){return;}
    if (mounted?.root.isConnected) { layoutCheck(); return; }
    mounted = null; clearTimeout(timer); observer?.disconnect(); started = Date.now();
    function attempt() {
      clearTimeout(timer); maps();
      try { if (initialise()) { observer?.disconnect(); observer=new MutationObserver(function(){clearTimeout(timer);timer=setTimeout(layoutCheck,80);}); observer.observe(mounted.root,{childList:true,subtree:true}); requestAnimationFrame(layoutCheck); return; } }
      catch (_) { diagnostic('layout-execution-error'); }
      if (Date.now() - started > 15000) { observer?.disconnect(); warning(); return; }
      timer = setTimeout(attempt, 250);
    }
    // Delayed theme/app hydration is allowed, but cannot retry or duplicate a
    // partially mounted form. Initialisation commits exactly once per section.
    observer = new MutationObserver(function () { if (!mounted) { clearTimeout(timer); timer = setTimeout(attempt,80); } });
    observer.observe(document.body,{childList:true,subtree:true}); attempt();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',start);
  window.addEventListener('resize',function(){if(mounted)requestAnimationFrame(layoutCheck);});
})();
